<form [formGroup]="lectureForm">
  <editor
    [init]="tinyInit"
    formControlName="rawData"
  >
  </editor>
</form>
